/**
 * Compliance product legal disclaimer.
 * Bump COMPLIANCE_DISCLAIMER_VERSION to force managers to re-accept.
 */
export const COMPLIANCE_DISCLAIMER_VERSION = '1';

export const COMPLIANCE_DISCLAIMER_TITLE = 'Compliance product disclaimer';

export const COMPLIANCE_DISCLAIMER_PARAGRAPHS: readonly string[] = [
  'Our Compliance product uses publicly available information, data obtained from public sources, and your payroll data to evaluate compliance.',
  'Evaluations and decisions are based on artificial intelligence (AI) and can be incorrect. AI can make mistakes. All results should be verified by a qualified human before you rely on them.',
  'Both false positives (flagging issues that are not real) and false negatives (missing issues that are real) are possible.',
  'We are not responsible for the accuracy of the information presented. By continuing, you acknowledge these limitations and agree to use the product accordingly.',
];

export const COMPLIANCE_DISCLAIMER_TABLE = 'compliance_disclaimer_acceptances';
